<template>
  <div>
    <flash-message transitionIn="animated swing"></flash-message>
    <b-row>
      <b-col xs="12" lg="12">
        <b-card>
          <div slot="header">
            {{ news.name }}
          </div>
          <b-card-body>
            <news-form
              :news="news"
              :edit-option="true"
            ></news-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import {News} from "../../models/News/News";
  import NewsForm from "../../components/News/NewsForm";

  export default {
    name: 'news-item',
    components: {
      NewsForm,
    },
    data (){
      return {
        news: new News(),
        newsId: this.$route.params.newsId,
      }
    },
    mounted () {
      RepositoryFactory
        .get('news')
        .getNews(this.newsId)
        .then(
          response => (
            this.news = new News(response.data.data)
          )
        )
    },
  }
</script>
